module.exports = __webpack_public_path__ + "img/header_logo.f87112c0.png";